import { useMemo } from 'react';

import { CopyrightIcon } from '@/components/common/icons';
import { Paragraph } from '@/components/common/text/Paragraph';

export function Copyrights() {
  const thisYear = useMemo(() => new Date().getFullYear(), []);

  return (
    <Paragraph>
      <CopyrightIcon className="inline-block" />
      <span className="ml-xs">Copyright 1993-{thisYear} PM-International</span>
    </Paragraph>
  );
}
